(() => {
  try {
    if (localStorage.getItem('dx-lang')) return;
    localStorage.setItem('dx-lang', '1');
    if (/bot|crawl|spider|slurp|lighthouse|facebookexternalhit|preview/i.test(navigator.userAgent)) return;
    const L = ['cs', 'de', 'fr', 'es', 'it', 'pl'];
    const cur = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
    // Visitor's main browser language if we have it, otherwise English.
    const first = String((navigator.languages && navigator.languages[0]) || navigator.language || 'en').slice(0, 2).toLowerCase();
    const want = L.includes(first) ? first : 'en';
    if (want === cur) return;
    const path = location.pathname.replace(/^\/(cs|de|fr|es|it|pl)(?=\/|$)/, '') || '/';
    location.replace((want === 'en' ? '' : `/${want}`) + path + location.search + location.hash);
  } catch (e) { /* storage blocked: keep the current language */ }
})();
